<template>
  <div class="box-father">
    <div>
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">值班值守&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>值班打卡</div>
          </div>
        </div>
      </div>
      <div class="ledger">
        <el-tabs v-model="activeName">
          <el-tab-pane label="值班表" name="first">
            <page v-if="activeName == 'first'"></page>
          </el-tab-pane>
          <el-tab-pane label="值班记录" name="second">
            <list v-if="activeName == 'second'"></list>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import list from "./list";
import page from "./page";
export default {
  components: {
    page,
    list
  },
  data() {
    return {
      activeName: "first"
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.ledger {
  background: #fff;
  padding: 16px 20px;
  height: calc(100% - 60px);
  .el-tabs {
    background: #fff;
  }
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/onDuty/index.vue